import { DatePicker as MuiDatePicker } from "@mui/x-date-pickers";

export default function DatePicker(props) {
  return <MuiDatePicker format="dd/MM/yyyy" {...props} />;
}
